<div class="content-loaf">
  <div class="row">
    <div class="col-6">
      <button class="btn btn-primary btn-primary-gradient btn-back" routerLink="/clinicstatuslist">一覧に戻る</button>
    </div>
    <div class="col-6 update-time-text">
      {{clinicStatus.updateTime | date: 'MM月dd日 HH時更新'}}
    </div>
  </div>

  <div class="table-responsive">
    <table class="table table-default reference-table table-bordered" style="margin-bottom: 0;">
      <thead>
        <tr class="center-block">
          <th colspan="2" class="institution-name"><span [innerHTML]="clinicStatus.institutionName.split('CRLF').join('<br />')"></span></th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <th style="width: 150px;">院長名</th>
          <td style="width: auto;">{{clinicStatus.directorName}}</td>
        </tr>

        <tr>
          <th>診療科目</th>
          <td>
            <span class="d-none d-md-block" [innerHTML]="clinicStatus.medicalCoursesName.split('CRLF').join('・')"></span>
            <span class="d-block d-md-none" [innerHTML]="clinicStatus.medicalCoursesName.split('CRLF').join('<br />')"></span>
          </td>
        </tr>

        <tr>
          <th>住所</th>
          <td>{{clinicStatus.address}}</td>
        </tr>

        <tr>
          <th>ＴＥＬ</th>
          <td>{{clinicStatus.tel}}</td>
        </tr>

        <tr>
          <th>ＦＡＸ</th>
          <td>{{clinicStatus.fax}}</td>
        </tr>
      </tbody>
    </table>

    <table class="table table-default reference-table table-bordered">
      <tbody>
        <tr class="center-block">
          <td class="symbol">
            <span class="symbol-red" *ngIf="clinicStatus.consultation == 0">✕</span>
            <span class="symbol-blue" *ngIf="clinicStatus.consultation == 1">○</span>
            <span class="symbol-gray" *ngIf="clinicStatus.consultation == 2">－</span>
            診療
          </td>

          <td class="symbol">
            <span class="symbol-red" *ngIf="clinicStatus.electricity == 0">✕</span>
            <span class="symbol-blue" *ngIf="clinicStatus.electricity == 1">○</span>
            <span class="symbol-gray" *ngIf="clinicStatus.electricity == 2">－</span>
            電気
          </td>
        </tr>

        <tr class="center-block">
          <td class="symbol">
            <span class="symbol-red" *ngIf="clinicStatus.waterSupply == 0">✕</span>
            <span class="symbol-blue" *ngIf="clinicStatus.waterSupply == 1">○</span>
            <span class="symbol-gray" *ngIf="clinicStatus.waterSupply == 2">－</span>
            水道
          </td>

          <td class="symbol">
            <span class="symbol-red" *ngIf="clinicStatus.phone == 0">✕</span>
            <span class="symbol-blue" *ngIf="clinicStatus.phone == 1">○</span>
            <span class="symbol-gray" *ngIf="clinicStatus.phone == 2">－</span>
            電話
          </td>
        </tr>

        <tr>
          <td colspan="2"><span class="comment" [innerHTML]="clinicStatus.comment"></span></td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="row">
    <div class="col-lg-10 col-md-9 col-7 explanation-text">
      ※<span [innerHTML]="clinicStatus.institutionName.split('CRLF').join('')"></span>の施設状況を変更する場合は、修正ボタンをクリック<br />
    </div>
    <div class="col-lg-2 col-md-3 col-5 right-block">
      <button class="btn btn-primary btn-primary-gradient" routerLink="/clinicstatusedit/{{clinicStatus.institutionId}}">修　正</button>
    </div>
  </div>
</div>
